import { render, staticRenderFns } from "./SurveyDesign.vue?vue&type=template&id=9a495914&scoped=true&"
import script from "./SurveyDesign.vue?vue&type=script&lang=js&"
export * from "./SurveyDesign.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDesign.vue?vue&type=style&index=0&id=9a495914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a495914",
  null
  
)

export default component.exports